var map = {
	"./b52.yaml": 118,
	"./banana_bread.yaml": 119,
	"./banana_cinnamon_pancake.yaml": 120,
	"./baozi_pork.yaml": 121,
	"./bazookajoe.yaml": 122,
	"./busiate.yaml": 123,
	"./cheesecake.yaml": 124,
	"./chicken_wrap.yaml": 125,
	"./chili_con_carne.yaml": 126,
	"./chocolate_chunk_cookies.yaml": 127,
	"./coffee_smoothie.yaml": 128,
	"./eggnogg.yaml": 129,
	"./eggtarts.yaml": 130,
	"./emperor_salad.yaml": 131,
	"./espresso_martini.yaml": 132,
	"./fajitas.yaml": 133,
	"./fondue.yaml": 134,
	"./fondue_alkoholfrei.yaml": 135,
	"./germknoedel.yaml": 136,
	"./guobaorou.yaml": 137,
	"./kaes_knoepfle": 70,
	"./kaes_knoepfle.json": 70,
	"./kaiserschmarrn.yaml": 138,
	"./koreanblackbean.yaml": 139,
	"./koreanfriedchicken.yaml": 140,
	"./koreanvegipancake.yaml": 141,
	"./lammschulter.yaml": 142,
	"./lasagna.yaml": 143,
	"./laziji.yaml": 144,
	"./mahua.yaml": 145,
	"./mantou.yaml": 146,
	"./mojito.yaml": 147,
	"./moscow_mule.yaml": 148,
	"./palatschinken.yaml": 149,
	"./penne_bolognese.yaml": 150,
	"./pilz_spaghetti.yaml": 151,
	"./pizza_dough.yaml": 152,
	"./pretty_raspberry_cake": 71,
	"./pretty_raspberry_cake.json": 71,
	"./raspberry_tiramisu.yaml": 153,
	"./revuelto_setas_langostinos.yaml": 154,
	"./semmelknoedel.yaml": 155,
	"./shan_waffels_2": 72,
	"./shan_waffels_2.json": 72,
	"./spaghetti_aglio_olio_e_gamberi.yaml": 156,
	"./spicypot.yaml": 157,
	"./sweet_potato_fries": 73,
	"./sweet_potato_fries.json": 73,
	"./tiramisu.yaml": 158,
	"./tiramisu_eggfree.yaml": 159,
	"./tortellini_tomato.yaml": 160,
	"./vanille_kipferl.yaml": 161,
	"./vegispaghetti_qielaxi.yaml": 162,
	"./vietnamese_egg_coffee.yaml": 163,
	"./wild_gschnetzlets.yaml": 164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 117;